import React from 'react';
export default function SlaCard({ card }: Readonly<{ card: any }>) {
  return (
    <div
      style={{
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        padding: 12,
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <div style={{ fontSize: 12, color: '#6b7280' }}>{card.label}</div>
      <div style={{ fontSize: 22, fontWeight: 500, color: '#0c1018' }}>{card.value}</div>
      <div style={{ fontSize: 12, color: card.ok ? '#059669' : '#dc2626' }}>{card.caption}</div>
    </div>
  );
}
